import { ObserversModule } from '@angular/cdk/observers';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { NgChartsModule } from 'ng2-charts';
import { CertificateRecordModule } from '../certificate-record/certificate-record.module';
import { CertificationProviderModule } from '../certification-provider/certification-provider.module';
import { AverageLearningTimeComponent } from './components/average-learning-time/average-learning-time.component';
import { CourseCompletionComponent } from './components/course-completion/course-completion.component';
import { AssignToTeamDialogComponent } from './components/dialogs/assign-to-team-dialog/assign-to-team-dialog.component';
import { TeamCertificationDialogComponent } from './components/dialogs/team-certification-dialog/team-certification-dialog.component';
import { MonthlyActiveDaysComponent } from './components/monthly-active-days/monthly-active-days.component';
import { PerformanceTeamMemberReviewComponent } from './components/performance-team-member-review/performance-team-member-review.component';
import { PerformanceTeamReviewComponent } from './components/performance-team-review/performance-team-review.component';
import { TeamApprovalRequestsComponent } from './components/team-approval-requests/team-approval-requests.component';
import { TeamBookingsComponent } from './components/team-bookings/team-bookings.component';
import { TeamCertificatesComponent } from './components/team-certificates/team-certificates.component';
import { TotalLearningTimeComponent } from './components/total-learning-time/total-learning-time.component';
import { UserProgressComponent } from './components/user-progress/user-progress.component';
import { UserTodosComponent } from './components/user-todos/user-todos.component';
import { TeamBookingOverviewApiService } from './services/team-booking-overview.api-service';
import { TeamMemberResolver } from './services/team-member.resolver';
import { TeamNavigationService } from './services/team-navigation.service';
import { TeamApiService } from './services/team.api-service';
import { TeamService } from './services/team.service';
import { TrackTeamSubTeamProgressService } from './services/track-team-subteam-progress.service';
import { UserTeamsResolver } from './user-teams.resolver';

@NgModule({
    imports: [
        MaxBrainSharedModule,
        MatChipsModule,
        MatIconModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatCardModule,
        MatButtonModule,
        MatInputModule,
        MatRadioModule,
        NgChartsModule,
        MatTooltipModule,
        CertificationProviderModule,
        CertificateRecordModule,
        MatTreeModule,
        MatStepperModule,
        ObserversModule,
    ],
    declarations: [
        CourseCompletionComponent,
        MonthlyActiveDaysComponent,
        AverageLearningTimeComponent,
        UserProgressComponent,
        TotalLearningTimeComponent,
        PerformanceTeamReviewComponent,
        PerformanceTeamMemberReviewComponent,
        TeamCertificatesComponent,
        TeamCertificationDialogComponent,
        TeamApprovalRequestsComponent,
        TeamBookingsComponent,
        UserTodosComponent,
        AssignToTeamDialogComponent,
    ],
    exports: [
        CourseCompletionComponent,
        MonthlyActiveDaysComponent,
        AverageLearningTimeComponent,
        UserProgressComponent,
        TotalLearningTimeComponent,
        PerformanceTeamReviewComponent,
        PerformanceTeamMemberReviewComponent,
        TeamCertificatesComponent,
        TeamCertificationDialogComponent,
        TeamApprovalRequestsComponent,
        TeamBookingsComponent,
        UserTodosComponent,
        AssignToTeamDialogComponent,
    ],
    providers: [TeamApiService, TeamService, TrackTeamSubTeamProgressService, UserTeamsResolver, TeamMemberResolver, TeamBookingOverviewApiService],
})
export class TeamModule {
    static forRoot(): ModuleWithProviders<TeamModule> {
        return {
            ngModule: TeamModule,
            providers: [TeamApiService, TeamNavigationService],
        };
    }
}
